// extracted by mini-css-extract-plugin
module.exports = {"infoItem":"InfoItem_infoItem__EZHRs","label":"InfoItem_label__zsW1T","value":"InfoItem_value__sDQKd"};